import * as React from 'react';
import { SidePanelItemActionEnum, SidePanelProps } from '../app/AppLayout';
import * as Classes from '../common/classes';

type Props = {
  selectedItem?: { action?: SidePanelItemActionEnum; key?: string };
  popUpRef: React.RefObject<HTMLDivElement>;
  sidePanelButtonsRef: React.RefObject<HTMLDivElement>;
  sidePanel?: SidePanelProps;
  onClose: () => void;
  renderContent: () => React.ReactNode;
};

const isUnderEl = (parentEl: HTMLDivElement | null, el: EventTarget | null) => {
  while (el !== null) {
    if (el === parentEl) {
      return true;
    }
    el = (el as HTMLElement).parentNode;
  }
  return false;
};

export const SidePanelContentRenderer: React.FC<Props> = ({
  selectedItem,
  popUpRef,
  sidePanelButtonsRef,
  sidePanel,
  onClose,
  renderContent,
}) => {

  React.useEffect(() => {
    if (selectedItem?.action !== SidePanelItemActionEnum.POPUP) {
      return undefined;
    }

    const closePopUpPanel = (ev: MouseEvent) => {
      if (
        !isUnderEl(popUpRef.current, ev.target) &&
        !isUnderEl(sidePanelButtonsRef.current, ev.target)
      ) {
        onClose();
      }
    };

    document.addEventListener('pointerdown', closePopUpPanel, false);
    document.addEventListener('click', closePopUpPanel, false);

    return () => {
      document.removeEventListener('pointerdown', closePopUpPanel, false);
      document.removeEventListener('click', closePopUpPanel, false);
    };
  }, [selectedItem?.action, onClose]);

  if (selectedItem?.action === SidePanelItemActionEnum.PIN_PANEL) {
    return (
      <div
        className={Classes.NAVBAR_ACTION_ITEM_MENU_PINNED}
        style={{
          minWidth: sidePanel?.panelWidth ?? 200,
          maxWidth: sidePanel?.maxWidth,
        }}
      >
        {renderContent()}
      </div>
    );
  }

  if (selectedItem?.action === SidePanelItemActionEnum.POPUP) {
    return (
      <div
        ref={popUpRef}
        className={Classes.NAVBAR_ACTION_ITEM_MENU_POPOVER}
        style={{
          minWidth: sidePanel?.panelWidth ?? 200,
          maxWidth: sidePanel?.maxWidth,
        }}
      >
        <div className={Classes.NAVBAR_ACTION_ITEM_MENU_POPOVER_CONTENT}>
          {renderContent()}
        </div>
      </div>
    );
  }

  return null;
};
